import React from "react";
import { CogSettingsIcon } from "assets";
import { JOBS_FEED_SETTINGS_PATHNAME } from "shared/config/common";

import { UrlCommand } from "shared/config/UrlCommand";

import PageKey from "config/PageKey";
import { IActionList } from "models/common";

import { IJobsPageTranslation } from "models/translation";
import { fallbackTranslation } from "services/api/fallbackData";
import { MY_FILTERS_FULL_PATH } from "config/common";

const fallbackPageTranslation = fallbackTranslation[PageKey.Jobs];

export enum ActionListItemKey {
  ChangeSettings = "changeSettings",
}

export function prepareActionList(
  pageTranslation: IJobsPageTranslation
): IActionList {
  return {
    moreButtonText: "",
    items: [
      {
        id: ActionListItemKey.ChangeSettings,
        text:
          pageTranslation?.shared?.pageHeaderButtonLabel ||
          fallbackPageTranslation.shared.pageHeaderButtonLabel,
        svgIconStart: <CogSettingsIcon width={16} height={16} />,
        linkUrl: `${JOBS_FEED_SETTINGS_PATHNAME}?${UrlCommand.ReturnUri}=${MY_FILTERS_FULL_PATH}`,
        variant: "primary",
      },
    ],
  };
}
